import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/CustomerContractAcceptance"
    : "SLN/SolarentOperator/CustomerContractAcceptance";

const CustomerContractAcceptanceReviewApi = {
  getByRequest: async (source, requestId) => {
    try {
      const res = await DefaultApiService.getCustomeApi(
        `${baseBySource(source)}/GetCustomerContractAcceptanceByRequest?requestId=${requestId}`
      );
      if (!res) {
        return { ok: false, message: "پاسخ خالی از سرور", data: null };
      }
      return {
        ok: res?.isSuccess !== false,
        message: res?.message || "",
        data: res?.data,
      };
    } catch (e) {
      return {
        ok: false,
        message:
          e?.response?.data?.message ||
          e?.message ||
          "خطا در دریافت وضعیت قرارداد",
        data: null,
      };
    }
  },

  reviewSignedCustomerContract: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/ReviewSignedCustomerContract`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  generateCustomerContractTemplate: async (source, requestId) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/GenerateCustomerContractTemplate?requestId=${requestId}`,
      {}
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },
};

export default CustomerContractAcceptanceReviewApi;
